<template>
    <div class="search-item" v-if="item">
        <span class="search-main-text">{{ item.main_text || item.name }}</span>
        <span class="search-secondary-text">{{item.secondary_text}}</span>
    </div>
</template>

<script>
    export default {
        props: {
            item: {required: true},
            searchText: {required: true}
        }
    }
</script>
<style scoped>
    .search-item {
        padding: 7px 10px;
    }

    .search-main-text {
        font-size: 18px;
        font-weight: bold;
    }

    .search-secondary-text {
        margin-left: 10px;
        font-size: 14px;
    }
</style>
